
import React, { useEffect, useMemo, useState } from "react";
import { Pencil, Trash, Calendar, X } from "lucide-react";
import "./member.css";

const API = "https://bodhimaram.onrender.com/api/students";

export default function Members({groupCode}) {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("add");
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(blankForm());
  

  /* ================= ROLE ================= */
  const user = JSON.parse(sessionStorage.getItem("role") || "{}");
  const role = (user.role || "").toLowerCase();
  const isTStaff = role === "tstaff";

  /* ================= FORM ================= */
  function blankForm() {
    return {
      id: null,
      childname: "",
      initial: "",
      parentname: "",
      primary_no: "",
      alternate_no: "",
      address: "",
      pincode: "",
      joining_date: "",
      fees_type: "",
      total_fees: "",
      fees_amount: "",
      cab_facility: "no",
      stop_location: "",
      cab_monthly_amount: "",
      student_image: null,
      student_image_url: "",
    };
  }

  /* ================= LOAD ================= */
  async function load() {
    if (!groupCode) return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/${groupCode}`);
      const data = await res.json();
      setMembers(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Load members failed", e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, [groupCode]);

  /* ================= MODAL ================= */
  function openAdd() {
    if (isTStaff) return;

     window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
    setMode("add");
    setForm(blankForm());
    setShowModal(true);
  }

  function openEdit(m) {
    if (isTStaff) return;
 window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

    setMode("edit");

const fullName = (m.childname || "").trim();
const parts = fullName.split(/\s+/);

let childName = fullName;
let initial = "";

if (parts.length > 1) {
  const lastWord = parts[parts.length - 1];

  // Treat as initial only if it's 1–3 alphabetic characters (with optional dot)
  const isInitial = /^[A-Za-z]{1,3}\.?$/.test(lastWord);

  if (isInitial) {
    initial = lastWord;
    childName = parts.slice(0, -1).join(" ");
  }
}

setForm({
  id: m.id,
  childname: childName,
  initial: initial,

      parentname: m.parentname || "",
      primary_no: m.primary_no || "",
      alternate_no: m.alternate_no || "",
      address: m.address || "",
      pincode: m.pincode || "",
      joining_date: m.joining_date ? m.joining_date.substring(0, 10) : "",
      fees_type: m.fees_type || "",
      total_fees: m.total_fees ?? "",
      fees_amount: m.fees_amount ?? "",
      cab_facility: m.cab_facility || "no",
      stop_location: m.stop_location || "",
      cab_monthly_amount: m.cab_monthly_amount ?? "",
      student_image: null,
      student_image_url: m.student_image || "",
    });
    setShowModal(true);
  }

  /* ================= SAVE ================= */
  async function save() {
  if (isTStaff) return;

  setSaving(true);

  try {
    const formData = new FormData();

const submitForm = {
  ...form,
childname: `${form.childname.trim()} ${
  form.initial.trim().toUpperCase().replace(/\.$/, "")
}`.trim(),
};

    // Append all form fields
    Object.entries(submitForm).forEach(([key, value]) => {
      if (
         key === "id" ||
  key === "student_image_url" ||
  key === "initial"
      ) return;

      // Image upload
      if (key === "student_image") {
        if (value instanceof File) {
          formData.append("student_image", value);
        }
        return;
      }

      // Ignore undefined/null only
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    // Group code only while adding
    if (mode === "add") {
      formData.set("group_code", groupCode);
    }

    let response;

    if (mode === "add") {
      response = await fetch(API, {
        method: "POST",
        body: formData,
      });
    } else {
      response = await fetch(`${API}/${form.id}`, {
        method: "PUT",
        body: formData,
      });
    }

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || "Save failed");
    }

    await load();

    setShowModal(false);

    alert(
      mode === "add"
        ? "✅ Student added successfully."
        : "✅ Student updated successfully."
    );
  } catch (err) {
    console.error("Save Error:", err);

    alert(err.message || "Failed to save student.");
  } finally {
    setSaving(false);
  }
}

  /* ================= DELETE ================= */
  async function removeMember(m) {
    if (isTStaff) return;

    if (!window.confirm(`Delete member "${m.childname}"?`)) return;
    const old = members;
    setMembers(prev => prev.filter(x => x.id !== m.id));
    try {
      const res = await fetch(`${API}/${m.id}`, { method: "DELETE" });
      if (!res.ok) throw new Error();
    } catch {
      alert("Delete failed");
      setMembers(old);
    }
  }

  /* ================= SEARCH ================= */
  const visible = useMemo(() => {
    if (!q.trim()) return members;
    const s = q.toLowerCase();
    return members.filter(
      m =>
        (m.childname || "").toLowerCase().includes(s) ||
        (m.parentname || "").toLowerCase().includes(s) ||
        (m.primary_no || "").includes(s)
    );
  }, [members, q]);

  /* ================= UI ================= */
  return (
    <section className="saaragkaMembers_card">

      {/* ===== MODAL ===== */}
      {!isTStaff && showModal && (
        <div className="saaragkaMembers_drawerOverlay" onClick={() => setShowModal(false)}>
          <div className="saaragkaMembers_drawer" onClick={e => e.stopPropagation()}>
            <div className="saaragkaMembers_modalHeader">
              <h3>{mode === "add" ? "Add Member" : "Edit Member"}</h3>
              <button onClick={() => setShowModal(false)}><X size={18} /></button>
            </div>

            <div className="saaragkaMembers_modalGrid">
              {/* Student Image */}
<div className="studentImageUpload">

  <label htmlFor="studentImage">

    {form.student_image ? (

      <img
        src={URL.createObjectURL(form.student_image)}
        alt="Student"
        className="studentPreview"
      />

    ) : form.student_image_url ? (

      <img
        src={`https://bodhimaram.onrender.com/uploads/students/${form.student_image_url}`}
        alt="Student"
        className="studentPreview"
      />

    ) : (

      <div className="studentPlaceholder">

        <span>📷</span>

        <small>Upload Photo</small>

      </div>

    )}

  </label>

  <input
    id="studentImage"
    type="file"
    accept="image/*"
    hidden
    onChange={(e) =>
      setForm((prev) => ({
        ...prev,
        student_image: e.target.files[0],
      }))
    }
  />

</div>
              {/* <label>Child Name *</label> 
              <input value={form.childname} onChange={e=>setForm(p=>({...p,childname:e.target.value}))} /> */}
<div className="childNameRow">

  <div className="childNameField">
    <label>Child Name *</label>
    <input
      value={form.childname}
      placeholder="Enter Child Name"
      onChange={e =>
        setForm(p => ({
          ...p,
          childname: e.target.value,
        }))
      }
    />
  </div>

  <div className="initialField">
    <label>Initial</label>
    <input
      value={form.initial}
      placeholder="S"
      maxLength={5}
      onChange={e =>
        setForm(p => ({
          ...p,
          initial: e.target.value.toUpperCase(),
        }))
      }
    />
  </div>

</div>


              <label>Parent Name *</label>
              <input value={form.parentname} onChange={e=>setForm(p=>({...p,parentname:e.target.value}))} />

              <label>Primary Phone *</label>
              <input value={form.primary_no} onChange={e=>setForm(p=>({...p,primary_no:e.target.value}))} />

<label>Alternate Phone</label>

<input
  value={form.alternate_no}
  onChange={(e) =>
    setForm((p) => ({
      ...p,
      alternate_no: e.target.value,
    }))
  }
/>

              <label>Address *</label>
              <input value={form.address} onChange={e=>setForm(p=>({...p,address:e.target.value}))} />

              <label>Pincode</label>
              <input value={form.pincode} onChange={e=>setForm(p=>({...p,pincode:e.target.value}))} />

              <label>Joining Date</label>
              <input type="date" value={form.joining_date} onChange={e=>setForm(p=>({...p,joining_date:e.target.value}))} />

<label>Fees Type</label>
              <select value={form.fees_type} onChange={e=>setForm(p=>({...p,fees_type:e.target.value}))}>
                <option value="">Select</option>
                <option value="term">Term</option>
                <option value="monthly">Monthly</option>
              </select>

 <label>Total Fees</label>
              <input type="number" value={form.total_fees} onChange={e=>setForm(p=>({...p,total_fees:e.target.value}))} />


              <label>Fees Amount</label>
              <input type="number" value={form.fees_amount} onChange={e=>setForm(p=>({...p,fees_amount:e.target.value}))} />


              {/* ✅ CAB FACILITY – UI CHANGE ONLY */}
              <label>Cab Facility</label>
              <div
                className={`cabSwitch ${form.cab_facility === "yes" ? "yes" : "no"}`}
                onClick={() =>
                  setForm(p => ({
                    ...p,
                    cab_facility: p.cab_facility === "yes" ? "no" : "yes"
                  }))
                }
              >
                {/* <span>{form.cab_facility === "yes" ? "YES" : "NO"}</span> */}
                <span
        style={{
      width: "100%",
      textAlign: form.cab_facility === "yes" ? "left" : "right",
       paddingLeft: form.cab_facility === "yes" ? "8px" : "0",
       paddingRight: form.cab_facility === "no" ? "8px" : "0"
          }}
              >
  {form.cab_facility === "yes" ? "YES" : "NO"}
</span>

                <div className="cabSwitchKnob" />
              </div>

              {form.cab_facility === "yes" && (
                <>
                  <label>Stop Location</label>
                  <input value={form.stop_location} onChange={e=>setForm(p=>({...p,stop_location:e.target.value}))} />

                  <label>Cab Monthly Amount</label>
                  <input type="number" value={form.cab_monthly_amount} onChange={e=>setForm(p=>({...p,cab_monthly_amount:e.target.value}))} />
                </>
              )}

              

            </div>

            <div className="saaragkaMembers_modalActions">
              <button onClick={() => setShowModal(false)} className="cancel">Cancel</button>
              <button disabled={saving} onClick={save} className="save">
                {saving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== HEADER ===== */}
      <div className="saaragkaMembers_header">
        <h3>Members <span>{visible.length}</span></h3>
        {/* <div className="saaragkaMembers_controls">
       
          <input
  className="saaragkaMembers_search"
  placeholder="Search Member..."
  value={q}
  onChange={e => setQ(e.target.value)}
/>
          {!isTStaff && <button onClick={openAdd}>+ Add Member</button>}
        </div>*/}
        <div className="saaragkaMembers_controls">

    <div className="saaragkaMembers_searchRow">

        <input
            className="saaragkaMembers_search"
            placeholder="🔍 Search by name, parent or phone..."
            value={q}
            onChange={e => setQ(e.target.value)}
        />

        {!isTStaff &&
            <button
                className="addMemberBtn"
                onClick={openAdd}
            >
                + Add
            </button>
        }

    </div>

</div>
      </div> 

{/* MOBILE SUMMARY */}
<div className="mobileMemberSummary">


    <div className="mobileSummaryCard">
        <div className="mobileIcon green">🎓</div>
        <h3>{members.length}</h3>
        <p>Total Students</p>
    </div>

    <div className="mobileSummaryCard">
        <div className="mobileIcon blue">🚌</div>
        <h3>
            {
                members.filter(
                    m=>m.cab_facility==="yes"
                ).length
            }
        </h3>
        <p>Cab Users</p>
    </div>

    {/* <div className="mobileSummaryCard">
        <div className="mobileIcon orange">₹</div>

        <h3>
        ₹{
            members.reduce(
                (a,b)=>a+Number(b.fees_amount||0),0
            )
        }
        </h3>

        <p>Total Fees</p>

    </div> */}

</div>

<div className="desktopMembersTable">
      {/* ===== TABLE ===== */}
      <div className="saaragkaMembers_tableWrap">
        {loading ? <p>Loading...</p> : (
          <table className="saaragkaMembers_table">
            <thead>
              <tr>
                <th>Photo</th>
                <th>Name</th>
                {!isTStaff && <th>Amount</th>}
                <th>Joining Date</th>
                {!isTStaff && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {visible.map(m => (
                <tr key={m.id}>
                  <td>
                    {m.student_image ? (
                      <img
                        src={`https://bodhimaram.onrender.com/uploads/students/${m.student_image}`}
                        alt=""
                        width={36}
                        height={36}
                        style={{ borderRadius: "50%" }}
                      />
                    ) : "-"}
                  </td>
                  <td>{m.childname}</td>
                  {!isTStaff && <td>₹{Number(m.fees_amount || 0)}</td>}
                  <td>
                    <Calendar size={14} />{" "}
                    {m.joining_date ? new Date(m.joining_date).toLocaleDateString() : "-"}
                  </td>
                  {!isTStaff && (
                    <td>
                      <button onClick={()=>openEdit(m)}><Pencil size={16} /></button>
                      <button onClick={()=>removeMember(m)}><Trash size={16} /></button>
                    </td>
                  )}
                </tr>
              ))}
              {!visible.length && (
                <tr>
                  <td colSpan={isTStaff ? 3 : 5} style={{ textAlign:"center", color:"#888" }}>
                    No members found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
      </div>



  <div className="mobileMembersList">

{visible.map((m)=>(
    
<div className="mobileMemberRow" key={m.id}>

    <div className="mobileLeft">

        {m.student_image ? (
            <img
                className="mobilePhoto"
                src={`https://bodhimaram.onrender.com/uploads/students/${m.student_image}`}
                alt=""
            />
        ) : (
            <div className="mobilePhotoAvatar">
                {m.childname?.charAt(0)}
            </div>
        )}

        <div className="mobileDetails">

            <h4>{m.childname}</h4>

            <p>{m.parentname}</p>

            <span>{m.primary_no}</span>

        </div>
         {!isTStaff && (

    <div className="mobileActions">

        <button onClick={()=>openEdit(m)}>
            <Pencil size={16}/>
        </button>

        <button onClick={()=>removeMember(m)}>
            <Trash size={16}/>
        </button>

    </div>

    )}


    </div>

    <div className="mobileRight">

        {/* <div>

            <small>Fees</small>

            <strong>₹{m.fees_amount}</strong>

        </div>

        <div>

            <small>Cab</small>

            <strong>{m.cab_facility==="yes"?"YES":"NO"}</strong>

        </div> */}

    </div>

   
</div>

))}

</div>
    </section>
  );
}
